import { useContext, useLayoutEffect } from 'react';
import { ConversationViewContext } from '../contexts/conversation-view-context';
import type { ConversationView } from '../types/conversation-view.types';

/** Reads the optional presentation registry; standalone panels need no global provider. */
export const useConversationView = () => useContext(ConversationViewContext);

/** Registers the actual mounted chat, including changes to its reading position. */
export const useRegisterConversationView = (view: ConversationView | null) => {
  const registry = useConversationView();
  const conversationId = view?.conversationId;
  const isAtBottom = view?.isAtBottom ?? false;
  useLayoutEffect(() => {
    if (conversationId === undefined) return;
    return registry?.register({ conversationId, isAtBottom });
  }, [registry, conversationId, isAtBottom]);
};
